import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SiteHeader from "./components/SiteHeader";
import HomePage from "./pages/HomePage";
import PropertiesPage from "./pages/PropertiesPage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import EstimatePage from "./pages/EstimatePage";
import FeesPage from "./pages/FeesPage";
import GuidesPage from "./pages/GuidesPage";
import GuideDetailPage from "./pages/GuideDetailPage";
import MarketReportPage from "./pages/MarketReportPage";
import WhatsAppContactButton from "./components/WhatsAppContactButton";
import SiteSeo from "./components/SiteSeo";
import AnalyticsConsent from "./components/AnalyticsConsent";
import PrivacyPage from "./pages/PrivacyPage";
import AnalyticsBridge from "./components/AnalyticsBridge";
import { AlertsPage, FavoritesPage, ReferralPage } from "./pages/UtilityPages";
import AgencyPage from "./pages/AgencyPage";
import ExpertisePage from "./pages/ExpertisePage";
import MandateDashboardPage from "./pages/MandateDashboardPage";
import AgentCardPage from "./pages/AgentCardPage";
import ShortCardRedirect from "./pages/ShortCardRedirect";
import { agents } from "./data/agents";
import "./pages/AgentCardPage.css";
import "./App.css";

const readStoredFavorites = () => {
  try {
    const storedFavorites = window.localStorage.getItem("pimp-my-place-favorites");
    const parsedFavorites = storedFavorites ? JSON.parse(storedFavorites) : [];
    return Array.isArray(parsedFavorites) ? parsedFavorites : [];
  } catch {
    return [];
  }
};

const persistFavorites = (favorites) => {
  try {
    window.localStorage.setItem("pimp-my-place-favorites", JSON.stringify(favorites));
  } catch {
    // Favorites remain available during the current session when storage is unavailable.
  }
};

function AppContent() {
  const location = useLocation();
  const isMandateDashboard = location.pathname.startsWith("/mandats");
  const isAgentCard = Boolean(agents[location.pathname.replace(/^\/(en\/)?|\/+$/g, "")]);
  const isBareLayout = isMandateDashboard || isAgentCard;
  const [favorites, setFavorites] = useState(readStoredFavorites);
  useEffect(() => {
    persistFavorites(favorites);
  }, [favorites]);
  const onFavorite = (property) => {
    setFavorites((current) => {
      const next = current.some((item) => item.id === property.id) ? current.filter((item) => item.id !== property.id) : [...current, property];
      return next;
    });
  };
  const shared = { favorites, onFavorite };
  return (
    <>
      <SiteSeo />
      {!isMandateDashboard && <AnalyticsBridge />}
      {!isBareLayout && <SiteHeader />}
      <Routes>
        <Route path="/" element={<HomePage {...shared} />} />
        <Route path="/biens" element={<PropertiesPage {...shared} />} />
        <Route path="/biens/:id" element={<PropertyDetailPage {...shared} />} />
        <Route path="/estimation" element={<EstimatePage />} />
        <Route path="/honoraires" element={<FeesPage />} />
        <Route path="/guides" element={<GuidesPage />} />
        <Route path="/guides/:slug" element={<GuideDetailPage />} />
        <Route path="/observatoire" element={<MarketReportPage />} />
        <Route path="/alertes" element={<AlertsPage />} />
        <Route path="/parrainage" element={<ReferralPage />} />
        <Route path="/confidentialite" element={<PrivacyPage />} />
        <Route path="/favoris" element={<FavoritesPage {...shared} />} />
        <Route path="/agence" element={<AgencyPage />} />
        <Route path="/expertise" element={<ExpertisePage />} />
        <Route path="/mandats" element={<MandateDashboardPage />} />
        <Route path="/c/:code" element={<ShortCardRedirect />} />
        <Route path="/:agentSlug" element={<AgentCardPage />} />
        <Route path="/en/:agentSlug" element={<AgentCardPage lang="en" />} />
      </Routes>
      {!isMandateDashboard && <AnalyticsConsent />}
      {!isBareLayout && <WhatsAppContactButton />}
      <Toaster theme="dark" richColors position="top-right" offset={{ top: 96, right: 20 }} />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
